// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__vthag menu-item_item___91Zf","itemLink":"item_itemLink__q5tYj","itemLink--active":"item_itemLink--active__gjp5M","itemIcon":"item_itemIcon__ZZwBg"};